// // components/ReviewsSlider.jsx
// import { useState, useEffect, useRef } from 'react';
// import { Box, IconButton, useMediaQuery, useTheme, Typography } from '@mui/material';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import { ReviewCard } from '../reviewCard/ReviewCard'; 

// export function ReviewsSlider({ reviews = [], programm_id, isAdmin, onDelete }) {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  
//   const [visibleCount, setVisibleCount] = useState(3);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [autoPlay, setAutoPlay] = useState(true);
//   const sliderRef = useRef(null);

//   // Защита от невалидных данных + сортировка по дате (свежие первыми)
//   const safeReviews = Array.isArray(reviews)
//     ? [...reviews].sort(
//         (a, b) => new Date(b.dateNewsFormat) - new Date(a.dateNewsFormat)
//       )
//     : [];

//   // Определяем количество видимых отзывов
//   useEffect(() => {
//     if (isMobile) {
//       setVisibleCount(1);
//     } else if (isTablet) {
//       setVisibleCount(2);
//     } else {
//       setVisibleCount(3);
//     }
//   }, [isMobile, isTablet]);

//   // Автопрокрутка
//   useEffect(() => {
//     if (!autoPlay || safeReviews.length <= visibleCount) return;
    
//     const interval = setInterval(() => {
//       setCurrentIndex(prev => 
//         prev >= safeReviews.length - visibleCount ? 0 : prev + 1
//       );
//     }, 5000);
    
//     return () => clearInterval(interval);
//   }, [autoPlay, safeReviews.length, visibleCount]);

//   const handlePrev = () => {
//     setAutoPlay(false);
//     setCurrentIndex(prev => 
//       prev === 0 ? Math.max(0, safeReviews.length - visibleCount) : prev - 1
//     );
//   };

//   const handleNext = () => {
//     setAutoPlay(false);
//     setCurrentIndex(prev => 
//       prev >= safeReviews.length - visibleCount ? 0 : prev + 1
//     );
//   };

//   // Получаем отзывы для отображения
//   const getVisibleReviews = () => {
//     if (safeReviews.length <= visibleCount) {
//       return safeReviews;
//     }
    
//     let endIndex = currentIndex + visibleCount;
//     if (endIndex > safeReviews.length) {
//       endIndex = safeReviews.length;
//     }
//     return safeReviews.slice(currentIndex, endIndex);
//   };

//   const visibleReviews = getVisibleReviews();

//   if (safeReviews.length === 0) {
//     return (
//       <Box sx={{ textAlign: 'center', py: 4 }}>
//         <Typography variant="h6">Отзывов пока нет</Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box
//       sx={{
//         position: 'relative',
//         width: '100%',
//         maxWidth: 1200,
//         mx: 'auto',
//         my: 6,
//         px: 2,
//       }}
//       onMouseEnter={() => setAutoPlay(false)}
//       onMouseLeave={() => setAutoPlay(true)}
//       ref={sliderRef}
//     >
//       <Typography 
//         variant="h4" 
//         sx={{ 
//           textAlign: 'center', 
//           mb: 4,
//           fontWeight: 'bold',
//           color: 'black'
//         }}
//       >
//         Отзывы о программе
//       </Typography>
      
//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           gap: 2,
//           position: 'relative',
//           minHeight: 300 // Чтобы не прыгало при загрузке
//         }}
//       >
//         {safeReviews.length > visibleCount && (
//           <IconButton
//             onClick={handlePrev}
//             sx={{
//               position: 'absolute',
//               left: 0,
//               zIndex: 1,
//               backgroundColor: 'rgba(255, 255, 255, 0.7)',
//               '&:hover': {
//                 backgroundColor: 'rgba(255, 255, 255, 0.9)',
//               },
//             }}
//           >
//             <ChevronLeftIcon fontSize="large" />
//           </IconButton>
//         )}

//         <Box
//           sx={{
//             display: 'flex',
//             gap: 2,
//             width: '100%',
//             justifyContent: 'center',
//             flexWrap: 'wrap'
//           }}
//         >
//           {visibleReviews.map((review, index) => (
//             <Box 
//               key={`${review.id || index}`}
//               sx={{
//                 flex: `0 0 calc(${100 / visibleCount}% - 16px)`,
//                 maxWidth: `calc(${100 / visibleCount}% - 16px)`,
//                 minWidth: 280
//               }}
//             >
//               <ReviewCard 
//                 review={review} 
//                 programm_id={programm_id} 
//                 isAdmin={isAdmin} 
//                 onDelete={onDelete} 
//               />
//             </Box>
//           ))}
//         </Box>

//         {safeReviews.length > visibleCount && (
//           <IconButton
//             onClick={handleNext}
//             sx={{
//               position: 'absolute',
//               right: 0,
//               zIndex: 1,
//               backgroundColor: 'rgba(255, 255, 255, 0.7)',
//               '&:hover': {
//                 backgroundColor: 'rgba(255, 255, 255, 0.9)',
//               },
//             }}
//           >
//             <ChevronRightIcon fontSize="large" />
//           </IconButton>
//         )}
//       </Box>

//       {/* Индикаторы */}
//       {safeReviews.length > visibleCount && (
//         <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
//           {Array.from({ length: Math.ceil(safeReviews.length / visibleCount) }).map((_, i) => (
//             <Box
//               key={i}
//               onClick={() => {
//                 setCurrentIndex(i * visibleCount);
//                 setAutoPlay(false);
//               }}
//               sx={{
//                 width: 10,
//                 height: 10,
//                 borderRadius: '50%',
//                 mx: 1,
//                 bgcolor: currentIndex === i * visibleCount ? 'primary.main' : 'action.disabled',
//                 cursor: 'pointer',
//                 transition: 'background-color 0.3s',
//                 '&:hover': {
//                   bgcolor: 'primary.light',
//                 },
//               }}
//             />
//           ))}
//         </Box>
//       )}
//     </Box>
//   );
// }

// components/ReviewsSlider.jsx
// components/ReviewsSlider.jsx - без stretch
// components/ReviewsSlider.jsx
// components/ReviewsSlider.jsx
import { useState, useEffect, useRef } from 'react';
import { Box, IconButton, useMediaQuery, useTheme, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ReviewCard } from '../reviewCard/ReviewCard'; 

export function ReviewsSlider({ reviews = [], programm_id, isAdmin, onDelete }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  
  const [visibleCount, setVisibleCount] = useState(3);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);
  const sliderRef = useRef(null);

  const safeReviews = Array.isArray(reviews)
    ? [...reviews].sort(
        (a, b) => new Date(b.dateNewsFormat || b.date) - new Date(a.dateNewsFormat || a.date)
      )
    : [];

  useEffect(() => {
    if (isMobile) {
      setVisibleCount(1);
    } else if (isTablet) {
      setVisibleCount(2);
    } else {
      setVisibleCount(3);
    }
  }, [isMobile, isTablet]);

  useEffect(() => {
    if (!autoPlay || safeReviews.length <= visibleCount) return;
    
    const interval = setInterval(() => {
      setCurrentIndex(prev => 
        prev >= safeReviews.length - visibleCount ? 0 : prev + 1
      );
    }, 5000);
    
    return () => clearInterval(interval);
  }, [autoPlay, safeReviews.length, visibleCount]);

  const handlePrev = () => {
    setAutoPlay(false);
    setCurrentIndex(prev => 
      prev === 0 ? Math.max(0, safeReviews.length - visibleCount) : prev - 1
    );
  };

  const handleNext = () => {
    setAutoPlay(false);
    setCurrentIndex(prev => 
      prev >= safeReviews.length - visibleCount ? 0 : prev + 1
    );
  };

  const getVisibleReviews = () => {
    if (safeReviews.length <= visibleCount) {
      return safeReviews;
    }
    
    let endIndex = currentIndex + visibleCount;
    if (endIndex > safeReviews.length) {
      endIndex = safeReviews.length;
    }
    return safeReviews.slice(currentIndex, endIndex);
  };

  const visibleReviews = getVisibleReviews();

  if (safeReviews.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="h6" sx={{ fontSize: '1.25rem' }}>Отзывов пока нет</Typography>
        <Typography variant="body1" sx={{ mt: 1, color: 'text.secondary', fontSize: '1rem' }}>
          Будьте первым, кто оставит отзыв о программе!
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: 'relative',
        width: '95%',
        maxWidth: 1400,
        mx: 'auto',
        my: 6,
        px: { xs: 1, sm: 2, md: 3 },
        py: 2, // 👈 ДОБАВИЛ ВЕРТИКАЛЬНЫЕ ОТСТУПЫ ДЛЯ ТЕНИ
      }}
      onMouseEnter={() => setAutoPlay(false)}
      onMouseLeave={() => safeReviews.length > visibleCount && setAutoPlay(true)}
      ref={sliderRef}
    >
      <Typography 
        variant="h4" 
        sx={{ 
          textAlign: 'center', 
          mb: 4,
          fontWeight: 'bold',
          fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
          color: 'text.primary'
        }}
      >
        Отзывы о программе
      </Typography>
      
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: { xs: 0.5, sm: 1, md: 2 },
          position: 'relative',
        }}
      >
        {/* Левая стрелка */}
        {safeReviews.length > visibleCount && (
          <IconButton
            onClick={handlePrev}
            sx={{
              flexShrink: 0,
              zIndex: 2,
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              boxShadow: 3,
              '&:hover': {
                backgroundColor: 'white',
              },
              width: { xs: 32, sm: 36, md: 40 },
              height: { xs: 32, sm: 36, md: 40 },
              ml: { xs: -1, sm: -1, md: 0 },
            }}
          >
            <ChevronLeftIcon fontSize="medium" />
          </IconButton>
        )}

        {/* Контейнер карточек - убираем overflow:hidden */}
        <Box
          sx={{
            display: 'flex',
            gap: { xs: 1.5, sm: 2, md: 3 },
            width: '100%',
            justifyContent: 'center',
            flexWrap: 'nowrap',
            // 👇 УБИРАЕМ overflow: hidden, тени теперь видны
          }}
        >
          {visibleReviews.map((review, index) => (
            <Box 
              key={review.id || review._id || `review-${index}`}
              sx={{
                flex: `0 0 calc(${100 / visibleCount}% - ${(visibleCount - 1) * (isMobile ? 6 : 8)}px)`,
                minWidth: { xs: 260, sm: 280, md: 300 },
                transition: 'transform 0.3s ease',
              }}
            >
              <ReviewCard 
                review={review} 
                programm_id={programm_id} 
                isAdmin={isAdmin} 
                onDelete={onDelete}
                showProgramInfo={false}
              />
            </Box>
          ))}
        </Box>

        {/* Правая стрелка */}
        {safeReviews.length > visibleCount && (
          <IconButton
            onClick={handleNext}
            sx={{
              flexShrink: 0,
              zIndex: 2,
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              boxShadow: 3,
              '&:hover': {
                backgroundColor: 'white',
              },
              width: { xs: 32, sm: 36, md: 40 },
              height: { xs: 32, sm: 36, md: 40 },
              mr: { xs: -1, sm: -1, md: 0 },
            }}
          >
            <ChevronRightIcon fontSize="medium" />
          </IconButton>
        )}
      </Box>

      {/* Индикаторы */}
      {safeReviews.length > visibleCount && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, flexWrap: 'wrap', gap: 0.5 }}>
          {Array.from({ length: Math.ceil(safeReviews.length / visibleCount) }).map((_, i) => (
            <Box
              key={i}
              onClick={() => {
                setCurrentIndex(i * visibleCount);
                setAutoPlay(false);
              }}
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                mx: 0.5,
                bgcolor: currentIndex === i * visibleCount ? 'primary.main' : 'action.disabled',
                cursor: 'pointer',
                transition: 'all 0.3s',
                '&:hover': {
                  bgcolor: 'primary.light',
                  transform: 'scale(1.2)',
                },
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}